import React from 'react';

import { Button, Group } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconAlertTriangle, IconCircleX } from '@tabler/icons-react';
import useCancelAthleteAppointment from 'hooks/athleteAppointment/useCancelAthleteAppointment';
import { AppointmentAthleteRetrieve } from 'types';

import ModalAthleteAppointmentDelete from './ModalAthleteAppointmentDelete';

const ACTION_MAP = {
  cancelReservation: {
    label: 'Cancel Reservation',
    Icon: IconCircleX,
  },
  lateCancelReservation: {
    label: 'Late Cancel',
    Icon: IconAlertTriangle,
  },
} as const;

type SupportedAction = keyof typeof ACTION_MAP;

type AppointmentCancelSectionProps = {
  appointmentData: AppointmentAthleteRetrieve;
  athleteAppointmentId: string;
  action: SupportedAction;
};

const AppointmentCancelSection = ({
  appointmentData,
  athleteAppointmentId,
  action,
}: AppointmentCancelSectionProps): JSX.Element | null => {
  const [opened, { open, close }] = useDisclosure(false);

  const deleteMutation = useCancelAthleteAppointment();

  const cancelInformation = ACTION_MAP[action];
  if (!cancelInformation) return null;

  const { label, Icon } = cancelInformation;

  return (
    <>
      <Group px='lg' position='center'>
        <Button
          size='md'
          variant='outline'
          leftIcon={<Icon />}
          onClick={open}
          color='red'
          loading={deleteMutation.isLoading}
        >
          {label}
        </Button>
      </Group>

      <ModalAthleteAppointmentDelete
        opened={opened}
        handleClose={close}
        deleteAthleteAppointmentMutation={deleteMutation}
        athleteAppointmentId={athleteAppointmentId}
        appointment={appointmentData}
      />
    </>
  );
};

export default AppointmentCancelSection;
